import { useEffect, useState } from "react";
import { api } from "../../../../service/api";
import { MileageDTO } from "../../../../dtos/MileageDTO";
import { useSearchParams } from "react-router-dom";

export function useShowMileage(id: string) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [dataList, setDataList] = useState<MileageDTO>({} as MileageDTO);

  const [searchParams] = useSearchParams();

  const start_date = searchParams.get("start_date") ?? "";
  const end_date = searchParams.get("end_date") ?? "";

  const fetchData = async (id: string) => {
    try {
      setLoading(true);
      const response = await api.get(
        `/company/car/mileage/show/${id}?start_date=${start_date}&end_date=${end_date}`
      );
      setDataList(response.data);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, start_date, end_date]);

  return {
    dataList,
    loading,
    error,
    refetch: fetchData,
  };
}
